'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = renderRoutes;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderComponent(basePath, route, props) {
  Object.assign(props, {
    children: renderRoutes(basePath, route.routes, route.extraProps, route.switchProps)
  });

  if (route.component) {
    return _react2.default.createElement(route.component, props);
  } else if (route.getComponent) {
    var Component = _react2.default.lazy(function () {
      return new Promise(function (resolve) {
        route.getComponent(props, function (RouteComponent, err) {
          if (err) {
            resolve(err.message || 'Error by getComponent' || route.loading);
          } else {
            resolve(RouteComponent);
          }
        });
      });
    });
    return _react2.default.createElement(
      _react.Suspense,
      { fallback: route.loading, key: 'redirect' },
      '(',
      _react2.default.createElement(Component, props),
      ')'
    );
  } else {
    return route.loading;
  }
}
function renderRoutes(basePath, routes, extraProps, switchProps) {
  if (extraProps === void 0) {
    extraProps = {};
  }
  if (switchProps === void 0) {
    switchProps = {};
  }
  return routes ? _react2.default.createElement(
    _reactRouterDom.Switch,
    (0, _extends3.default)({ key: 'switch' }, switchProps),
    routes.map(function (route, i) {
      if (!route.element) {
        var exact = route.exact || !route.routes || !route.routes.length;
        var relativePath = _path2.default.normalize('/' + (route.resolvePath || route.path || route.name));
        if (relativePath === route.resolvePath) {
          if (!route.navKey && route.resolvePath.indexOf(basePath) === -1) {
            route.resolvePath = _path2.default.normalize(basePath + relativePath);
          }
        } else {
          route.resolvePath = _path2.default.normalize(basePath + relativePath);
        }
        var routeProps = {
          path: relativePath,
          exact: exact,
          strict: route.strict,
          route: route
        };
        routeProps.render = function render(props) {
          props.route = route;
          /* eslint-disable react/prop-types */
          if (route.indexRoute && props.match.isExact && props.match.path !== route.indexRoute.path) {
            if (route.indexRoute.path) {
              return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(_reactRouterDom.Redirect, { key: 'redirect', to: _path2.default.normalize('/' + route.indexRoute.path) }),
                renderComponent(basePath, route, props)
              );
            } else {
              return renderComponent(basePath, route.indexRoute, { key: 'redirect' });
            }
          }
          return renderComponent(basePath, route, props);
        };
        route.element = _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({ key: route.key || i }, routeProps));
      }
      return route.element;
    })
  ) : null;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/renderRoutes.js
// module id = 177
// module chunks = 0